/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface ICareerSearch {
        occupations: any[];
        searchTerm: string;
        restResult: IRestResult<IOccupationResult>
        page: number;
        pageSize: number;
        careerClusters: ICareerCluster[];
        interestAreaId: number;
        interestProfilerResults: IInterestAreaResult[];
        careerClusterSurveyResults: ICareerClusterResult[];
        basicSkillsSurveyResults: ICategoryResult[];
        workValuesResults: IWorkValueSorterResult[];
        careerKeyResults: IInterestAreaResult[];
        skillId: number;
        workValueId: number;
        searchType: string;
        searchId: number;
        loading: boolean;
    }

    interface IOccupationResult {
        id: number;
        occCode: string;
        occTitle: string;
        description: string;
        url: string;
        urlName: string;
    }

    interface ICareerCluster {
        id: number;
        code: number;
        title: string;
        description: string;
    }

    interface ISearchParams {
        search?: string;
        pageSize?: number;
        page?: number;
        careerClusterId?: number;
        interestAreaId?: number;
        skillId?: number;
        searchType?: string;
        searchId?: number;
    }

    class CareerSearch implements ICareerSearch {
        static controllerId: string = "careerSearch";
        static $inject: string[] = ["$scope", "common", "config", "Restangular", "$location", "$routeParams", "$q", "$anchorScroll", "$uibModal"];

        occupations: any[];
        searchTerm: string;
        restResult: IRestResult<any>
        page: number;
        pageSize: number = 10;
        careerClusters: ICareerCluster[];
        baseUrl: string;
        careerClusterId: number;
        interestAreaId: number;
        interestProfilerResults: IInterestAreaResult[];
        careerClusterSurveyResults: ICareerClusterResult[];
        basicSkillsSurveyResults: ICategoryResult[];
        workValuesResults: IWorkValueSorterResult[];
        careerKeyResults: IInterestAreaResult[];
        skillId: number;
        workValueId: number;
        searchType: string;
        searchId: number;
        loading: boolean = true;

        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;


        constructor(private $scope: ng.IScope, private common: ICommonFactory, private config: IConfig, private Restangular: Restangular.IService, private $location: ng.ILocationService, private $routeParams: ng.route.IRouteParamsService, private $q: ng.IQService, private $anchorScroll: ng.IAnchorScrollService, private $uibModal: angular.ui.bootstrap.IModalService) {

            this.log = common.logger.getLogFn(CareerSearch.controllerId);
            this.logError = common.logger.getLogFn(CareerSearch.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(CareerSearch.controllerId, "success");
            this.baseUrl = config.ncCareersUrl;

            this.activate();
        }


        activate() {
            var promises = [this.getCareerClusters(), this.getAssessmentResults()];


            if (Object.keys(this.$location.search()).length > 0) {
                this.searchTerm = this.$location.search().s;
                this.page = this.$location.search().p;

                this.searchType = this.$location.search().searchType;
                this.searchId = this.$location.search().searchId;
            }

            var command = sessionStorage.getItem("careers.command");

            if (command == "savedcareers") {
                this.searchType = "savedcareers";
            }

            if (command == "save") {
                var params = JSON.parse(sessionStorage.getItem("careers.parameters"));
                if (params) {
                    promises.push(this.getCareers(params));
                }

                var occupation = JSON.parse(sessionStorage.getItem("careers.occupation"));
                if (occupation) {
                    this.saveCareer(occupation);
                }
            }

            if (this.searchType) {
                promises.push(this.getCareers(this.getParams()));
            }
            else if (this.searchTerm) {
                promises.push(this.search(this.page));
            }
            else {
                this.resetSearch();
            }

            this.$scope.$on("$routeUpdate", () => {
                //if (this.$location.hash()) {
                //    this.getState();
                //}
                //else if (Object.keys(this.$location.search()).length > 0) {
                //    this.getState();
                //}
                this.getState();
            });

           
            this.common.activateController(promises, CareerSearch.controllerId).finally(() => {
                this.loading = false;
            });
        }

        getAssessmentResults() {
            var defer = this.$q.defer();
            this.common.authentication.isLoggedIn().then((loggedIn) => {
                if (loggedIn) {
                    this.$q.all([
                        this.getInterestProfilerSession(),
                        this.getCareerClusterSurveySession(),
                        this.getBasicSkillsSession(),
                        this.getWorkValuesSession(),
                        this.getCareerKeySession()
                    ]).then(() => {
                        defer.resolve();
                    }, (reason) => {
                        this.logError(reason.message, reason, false);
                        defer.resolve();
                    });
                } else {
                    defer.resolve();
                }
            });
            return defer.promise;
        }

        getState() {
            if (this.$location.state()) {
                this.searchTerm = this.$location.state().searchTerm;
                this.restResult = this.$location.state().restResult ? JSON.parse(this.$location.state().restResult) : null;
                this.page = this.$location.state().page ? this.$location.state().page : 1;
                this.careerClusterId = this.$location.state().careerClusterId ? this.$location.state().careerClusterId : null;
                this.interestAreaId = this.$location.state().interestAreaId ? this.$location.state().interestAreaId : null;
                this.skillId = this.$location.state().skillId ? this.$location.state().skillId : null;
                this.workValueId = this.$location.state().workValueId ? this.$location.state().workValueId : null;

                this.searchType = this.$location.state().searchType ? this.$location.state().searchType : null;
                this.searchId = this.$location.state().searchId ? this.$location.state().searchId : null;
            }

            if (this.restResult == null &&
                (this.searchTerm || this.careerClusterId || this.interestAreaId || this.skillId || this.workValueId || this.searchId || this.searchType)) {
                this.search(this.page);
            }
        }

        saveState() {
            var state = {
                searchTerm: this.searchTerm,
                restResult: JSON.stringify(this.restResult),
                page: this.page,
                searchType: this.searchType,
                searchId: this.searchId
            };


            this.$location.search({ s: this.searchTerm, p: this.page, searchType: this.searchType, searchId: this.searchId });
            return this.$location.state(state);
        }

        getCareerClusters() {
            return this.Restangular.all("careers").one("clusters").get()
                .then((result: ICareerCluster[]) => {
                    this.careerClusters = result;
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        getCareers(params: ISearchParams | string): angular.IPromise<void> {
            this.loading = true;
            if (typeof (params) == "string") {
                return this.Restangular.oneUrl("occupations", params).get()
                    .then((result) => {
                        this.restResult = result;
                        this.saveState();
                    }, (reason) => {
                        this.logError(reason.message, reason, true);
                    }, () => this.loading = false);
            }
            else {
                var defer = this.common.$q.defer<void>();
                var authDefer = this.common.$q.defer<void>();
                if (params.searchType == "savedcareers") {
                    sessionStorage.setItem("careers.command", "savedcareers");
                    authDefer.promise = this.common.authentication.authenticate(true)
                        .then(() => {
                            sessionStorage.removeItem("careers.command");
                        }, reasone => { },
                        () => this.loading = false);
                }
                else {
                    this.loading = false;
                    authDefer.resolve();
                }

                authDefer.promise.then(() => {
                    defer.promise = this.Restangular.all("careers").one("occupations").get(params)
                        .then((result) => {
                            this.restResult = result;
                            this.saveState();
                            defer.resolve();
                        }, (reason) => {
                            this.logError(reason.message, reason, true);
                            defer.reject(reason);
                        }, () => this.loading = false);
                })

                return defer.promise;
            }
        }


        search(page) {
            this.restResult = null;
            this.page = null;
            this.careerClusterId = null;
            this.interestAreaId = null;
            this.skillId = null;
            this.workValueId = null;
            this.searchType = null
            this.searchId = null
            this.page = page;

            var params = this.getParams()

            return this.getCareers(params);
        }

        selectSearchType(searchType: string, id: number) {
            this.searchType = searchType;
            this.searchId = id;

            var params = this.getParams();

            this.getCareers(params);
            this.$anchorScroll("top");
        }


        resetSearch(clearSearchTerm?: boolean) {
            if (clearSearchTerm) {
                this.searchTerm = null;
            }

            this.searchTerm = null;
            this.restResult = null;
            this.page = null;
            this.careerClusterId = null;
            this.interestAreaId = null;
            this.skillId = null;
            this.workValueId = null;
            this.searchType = null
            this.searchId = null

            this.saveState();
            
        }

        getParams(): ISearchParams {
            return {
                search: this.searchTerm,
                pageSize: this.pageSize,
                page: this.page,
                searchType: this.searchType,
                searchId: this.searchId
            }
        }

        getAssessmentSession(id: number) {
            return this.Restangular.one("assessments", id).one("sessions").get<IAssessmentSession[]>()
                .then((sessions: IAssessmentSession[]) => {
                    var lastSession = _.first(_.orderBy(_.reject(sessions, (s) => {
                        return s.dateCompleted == null || s.isNCDCAssessment == true;
                    }), ["dateCompleted"], ["desc"]));
                    return lastSession;
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        getCareerClusterSurveySession() {
            this.getAssessmentSession(2).then((session: IAssessmentSession) => {
                if (session) {
                    this.Restangular.all("assessments/career-cluster-survey").one("sessions", session.id).one("results").get()
                        .then((result: ICareerClusterResult[]) => {
                            result = _.orderBy(result, ["count"], ["desc"]);
                            this.careerClusterSurveyResults = _.filter(result, (ar) => ar.count >= result[2].count && ar.count != 0);
                        }, (reason) => {
                            this.logError(reason.message, reason, true);
                        });
                }
            });
        }

        getInterestProfilerSession() {
            return this.Restangular.one("assessments", 1).one("sessions").get<IAssessmentSession[]>()
                .then((sessions: IAssessmentSession[]) => {
                    var lastSession = _.first(_.orderBy(_.reject(sessions, (s) => {
                        return s.dateCompleted == null || s.isNCDCAssessment == true;
                    }), ["dateCompleted"], ["desc"]));

                    if (lastSession) {
                        this.Restangular.all("assessments/interest-profiler").one("sessions", lastSession.id).one("results").get()
                            .then((result) => {
                                this.interestProfilerResults = result;
                            }, (reason) => {
                                this.logError(reason.message, reason, true);
                            });
                    }
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        getBasicSkillsSession() {
            this.getAssessmentSession(3).then((session: IAssessmentSession) => {
                if (session) {
                    this.Restangular.all("assessments/basic-skills-survey").one("sessions", session.id).one("results").get()
                        .then((result: ICategoryResult[]) => {
                            result = _.orderBy(result, ["count"], ["desc"]);
                            this.basicSkillsSurveyResults = _.filter(result, (ar) => ar.count >= result[2].count && ar.count != 0);
                        }, (reason) => {
                            this.logError(reason.message, reason, true);
                        })
                }
            });
        }



        getWorkValuesSession() {
            this.getAssessmentSession(5).then((session: IAssessmentSession) => {
                if (session) {
                    this.Restangular.all("assessments/work-values-sorter").one("sessions", session.id).one("results").get()
                        .then((result: IWorkValueSorterResult[]) => {
                            result = _.orderBy(result, ["score"], ["desc"]);
                            this.workValuesResults = _.filter(result, (ar) => ar.score >= result[2].score && ar.score != 0);
                        }, (reason) => {
                            this.logError(reason.message, reason, true);
                        })
                }
            });
        }

        getCareerKeySession() {
            this.getAssessmentSession(6).then((session: IAssessmentSession) => {
                if (session) {
                    this.Restangular.all("assessments/the-career-key").one("sessions", session.id).one("results").get()
                        .then((result: IInterestAreaResult[]) => {
                            result = _.orderBy(result, ["count"], ["desc"]);
                            this.careerKeyResults = _.filter(result, (ar) => ar.count >= result[2].count && ar.count != 0);
                        }, (reason) => {
                            this.logError(reason.message, reason, true);
                        })
                }
            });
        }

        pageResults() {
            this.getCareers(this.getParams());
            this.$anchorScroll("top");
        }

        saveCareer(occupation) {
            if (sessionStorage.getItem("careers.command") == null) {
                sessionStorage.setItem("careers.command", "save");
                sessionStorage.setItem("careers.parameters", JSON.stringify(this.getParams()));
                sessionStorage.setItem("careers.occupation", JSON.stringify(occupation));
            }

            this.common.authentication.authenticate(true).then(() => {
                sessionStorage.removeItem("careers.command");
                sessionStorage.removeItem("careers.parameters");
                sessionStorage.removeItem("careers.occupation");

                if (!occupation.isSaved) {
                    var modalInstance = this.$uibModal.open({
                        templateUrl: "/app/common/confirmationModal.html",
                        controller: "confirmationModal",
                        resolve: {
                            data: {
                                title: "Save Career",
                                content: `Are you sure you want to add ${occupation.occTitle} to your list of Saved Careers?`
                            }
                        }
                    });

                    modalInstance.result.then(result => {
                        if (result) {
                            this.Restangular.all("careers/savedcareers").post({ OCCCode: occupation.occCode }).then(() => {
                                occupation.isSaved = true;
                                this.logSuccess("Saved successfully to your Saved Careers", "Saved successfully to your Saved Colleges.", true);
                            }, (reason) => {
                                this.logError(reason, reason, true);
                            });
                        }
                    });
                } else {
                    var modalInstance = this.$uibModal.open({
                        templateUrl: '/app/common/confirmationModal.html',
                        controller: 'confirmationModal',
                        resolve: {
                            data: {
                                title: "Remove Saved College",
                                content: `Are you sure you wish to remove ${occupation.occTitle} from your Saved Careers?`
                            }
                        }
                    });
                    modalInstance.result.then((result) => {
                        if (result) {
                            this.Restangular.one("careers/savedcareers").remove({ occCode: occupation.occCode }).then((results) => {
                                occupation.isSaved = false;
                                this.logSuccess("Successuflly removed from your Saved Colleges.", null, true);
                            }, (reason) => {
                                this.logError(reason, reason, true);
                            });
                        }
                    });
                }

            });
        }

    }


    angular.module("app").controller(CareerSearch.controllerId, CareerSearch);
}